/**
 * Creates a new vehicle editor state.
 * @param VinLookupService vin manipulation service.
 * @param dto vehicle DTO to edit.
 * @param onSuccess callback of type () => Unit
 * @param onCancel cancellation callback of type () => Unit
 */
define(['edge/quoteandbind/quickquote/pa/util/AsyncLookup'], (asyncLookup) => (VinLookupService) => {
    const makeLookup = asyncLookup(() =>
        VinLookupService.lookupMakes('quoteandbind').then(x => x.makes));
    makeLookup.load();

    const modelLookup = asyncLookup(make =>
        VinLookupService.autofillBasedOnPartialDto('quoteandbind', {make}).then(x => x.models));
    const yearsLookup = asyncLookup((make, model) =>
        VinLookupService.autofillBasedOnPartialDto('quoteandbind', {make, model}).then(x => x.years));

    return ({dto, onSubmit, onCancel}) => {

        function isValid() {
            return dto.make.aspects.valid && dto.model.aspects.valid && dto.year.aspects.valid;
        }

        const EMPTY = [];

        return {
            'make': {
                get value() {
                    return dto.make.value;
                },
                set value(nv) {
                    dto.make.value = nv;
                    modelLookup.load(nv);
                },
                'aspects': Object.create(dto.make.aspects, {
                    availableValues: {'get': () => makeLookup.state.value || EMPTY}
                })
            },
            'model': {
                get value() {
                    return dto.model.value;
                },
                set value(nv) {
                    dto.model.value = nv;
                    yearsLookup.load(dto.make.value, nv);
                },
                'aspects': Object.create(dto.model.aspects, {
                    availableValues: {'get': () => modelLookup.state.value || EMPTY}
                })
            },
            'year': {
                get value() {
                    return dto.year.value;
                },
                set value(nv) {
                    dto.year.value = nv;
                },
                'aspects': Object.create(dto.year.aspects, {
                    availableValues: {'get': () => yearsLookup.state.value || EMPTY}
                })
            },
            cancel: onCancel,
            submit() {
                if (isValid()) {
                    onSubmit();
                }
            }
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/vehicle/models/VehicleEditState.js
 **/